import type { FC } from 'react';
import { useCallback } from 'react';
import type { ActionProps } from '../../types';
import { observer } from 'mobx-react-lite';
import useRulePageMode from '../../hooks/useRulePageMode';
import { useFormContext } from 'react-hook-form';
import useCurrentTasksFormStore from '../../hooks/useCurrentTasksFormStore';
import type { OptionValue } from '../../../../types/shared';
import { RuleEditAutoCompleteStyled } from '../RuleEditTasksFormComponents';
import useActions from '../../hooks/useActions';

export const ActionType: FC<ActionProps> = observer(({ indexAction, indexTask, field, indexVariant }) => {
  const { isRead } = useRulePageMode();
  const isVariant = typeof indexVariant === 'number';
  const { watch } = useFormContext();
  const ruleLevel = watch('level') as string;
  const tasksFormStore = useCurrentTasksFormStore();
  const handleChangeMetric = useCallback(
    (value: OptionValue) => {
      tasksFormStore.setActionFieldValue({
        indexTask,
        indexAction,
        field,
        value: value as string,
      });
    },
    [tasksFormStore, indexTask, indexAction, field]
  );

  const { options } = useActions({ ruleLevel, indexTask });

  const storedValue = tasksFormStore.getActionValues({ indexTask, indexAction, indexVariant })[field];

  return (
    <RuleEditAutoCompleteStyled
      allSelectable={false}
      value={storedValue ?? ''}
      onChange={handleChangeMetric}
      id={`Autocomplete-${field}-${indexTask}-${indexAction}`}
      options={options}
      InputProps={{
        ...(tasksFormStore?.propsRestriction ?? null),
        disabled: isRead || isVariant,
      }}
    />
  );
});

export default ActionType;
